const getSumOfArray = (values) => {
  if (values.length) {
    return values.reduce((a, b) => a + b, 0);
  } else {
    return 0;
  }
};

const getSumOfArrayOfObjects = (array, key) => {
  if (array && array.length) {
    return array.reduce((a, b) => a + (b[key] || 0), 0);
  } else {
    return 0;
  }
};

//Haversine formula to calculate distance between two points
const getDistance = (lat1, lon1, lat2, lon2) => {
  if (lat1 && lon1 && lat2 && lon2) {
    let earthRadiusKm = 6371;

    let dLat = degreesToRadians(lat2 - lat1);
    let dLon = degreesToRadians(lon2 - lon1);

    lat1 = degreesToRadians(lat1);
    lat2 = degreesToRadians(lat2);

    let a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
    let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    let distKm = earthRadiusKm * c;

    return (distKm * 0.621361).toFixed(0);
  }
};

const getETA = (date, miles, speed) => {
  if (date && miles) {
    const ETA = (miles/speed)*60*60*1000;
    date.setMilliseconds(date.getMilliseconds() + ETA);
    return {
      newETA: date.toISOString(),
      minutesRemaining: (miles/speed)*60
    };
  }
};

function degreesToRadians(degrees) {
  return degrees * Math.PI / 180;
}

export {
  getSumOfArray,
  getSumOfArrayOfObjects,
  getDistance,
  getETA
};